import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { withRouter } from 'react-router-dom';
import IconSport from './-IconSport';
import MarginInfo from './-MarginInfo';
import FavouriteStar from '../favouriteStar/';
import Counter from './liveMenuCounter';

@withRouter
@inject('lineStore', 'routingStore')
@observer
class LiveMenuItemPopular extends Component {
  selectItem = (evt) => {
    // const {sport_id, league} = this.props.lineStore.menu.popular.items[this.props.id];
    this.props.history.push(`/${this.props.lineStore.menu.mode}/popular/${this.props.id}`);
    // this.props.lineStore.menu.selectItem(this.props.id, this.props.type);
    evt.preventDefault();
  }

  render() {
    const { sport, id, games_count, increased_odds } = this.props.lineStore.menu.popular.items[this.props.id];
    const { dict } = this.props.lineStore.menu;
    const label = 'popular' in dict && id in dict.popular ? dict.popular[id] : '';

    return (
      <div className="line-popular-group-item">
        <FavouriteStar
          type={4}
          id={id}
        />
        {
          increased_odds ?
            <button
              title={label}
              className="line-popular-item-load l-p-i-l"
              onClick={this.selectItem}
            >
              <IconSport sportId={'margin'} />
              <div className="favourites-item-load-label">{label}</div>
              <MarginInfo />
              <Counter count={games_count} />
            </button>
            :
            <button
              title={label}
              className="line-popular-item-load l-p-i-l"
              onClick={this.selectItem}
            >
              <IconSport sportId={sport[0]} />
              <div className="favourites-item-load-label">{label}</div>
              <Counter count={games_count} />
            </button>
        }
      </div>
    );
  }
}

export default LiveMenuItemPopular;


// WEBPACK FOOTER //
// ./src/components/liveMenu/liveMenuItemPopular.jsx